import { render } from "./LinkExpirado.vue?vue&type=template&id=fc6185dc"
import script from "./LinkExpirado.vue?vue&type=script&lang=js"
export * from "./LinkExpirado.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Desenvolvimento\\projetos\\web\\cliqx.checkout.frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__